module.exports = __webpack_public_path__ + "static/media/mofa-logo-red.dff96b3e.svg";